import { ActionModal } from "./ActionModal";
import { channels, editable, type Channel } from "./master";

/** 摘除或恢复通道的二次确认：整行 PUT，只翻转 manually_removed，保存即生效并进审计（决策 D57）。通道配置页与通道健康页共用。 */
export function ChannelRemoveModal({ row, onClose }: { row: Channel; onClose: () => void }) {
  const restore = row.manually_removed;
  return (
    <ActionModal title={`${restore ? "恢复" : "摘除"}通道 ${row.name}`} confirmLabel={restore ? "恢复通道" : "摘除通道"} danger={!restore}
      action={() => channels.update(row.id, { ...editable(row), manually_removed: !restore })} invalidate={["channels"]}
      message={restore ? `已恢复通道 ${row.name}` : `已摘除通道 ${row.name}`} onClose={onClose}
      note={<>{restore ? "恢复后路由重新可以选择该通道。" : "摘除后路由立即不再选择该通道，在途消息继续等待回执。"}此操作写入审计日志。</>} />
  );
}
